import {ApiException} from "@/domain/core/exception/exceptions";

const state = {
    users: [],
    user: null
}

export const getters = {
    users: state => state.users,
    user: state => state.user,
}


export const mutations = {
    users(state, users) {
        state.users = users
    },
    user(state, user) {
        state.user = user
    }
}


export const actions = service => ({
    async searchUsers({commit}, filters) {
        try {
            commit('users', await service.searchUsers(filters))
        } catch (e) {
            if (e instanceof ApiException)
                commit('users', [])
            throw e
        }
    },
    async fetchUser({commit}, id) {
        commit('user', null)
        commit('user', await  service.fetchUser(id))
    },
    async reactivate({commit, getters}) {
        commit('user', await service.reactivate(getters.user.id))
    },
    async deactivate({commit, getters}) {
        commit('user', await service.deactivate(getters.user.id))
    },
    async changePassword({commit, getters}, password) {
        commit('user', await service.changePassword(getters.user.id, password))
    },
    async enableDashboard({commit, getters}) {
        commit('user', await service.enableDashboard(getters.user.id))
    },
    async disableDashboard({commit, getters}) {
        commit('user', await service.disableDashboard(getters.user.id))
    },
    async setVirtualUser({commit, getters}, userId) {
        const targetId = userId || getters.user?.id
        const result = await service.setVirtualUser(targetId)
        if (getters.user?.id === targetId) commit('user', result)
        return result
    },
    async unsetVirtualUser({commit, getters}, userId) {
        const targetId = userId || getters.user?.id
        const result = await service.unsetVirtualUser(targetId)
        if (getters.user?.id === targetId) commit('user', result)
        return result
    },
    async changeAccountEmail({commit, getters}, {userId, email}) {
        const targetId = userId || getters.user?.id
        const result = await service.changeAccountEmail(targetId, email)
        if (getters.user?.id === targetId) commit('user', result)
        return result
    },
    // eslint-disable-next-line no-unused-vars
    async fetchCollaborators({commit}, userId) {
        return await service.fetchCollaborators(userId)
    },
})

export default service => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(service)
})

